const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chat location share home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M321.1,405.127a41.4,41.4,0,0,0-6.8-.964c-15.276-1.428-28.987-4.218-28.987-22.428V316.807a27.975,27.975,0,0,0-27.943-27.944H37.943A27.975,27.975,0,0,0,10,316.807V452.459A27.974,27.974,0,0,0,37.943,480.4H257.371a27.974,27.974,0,0,0,27.943-27.943V443.53a1.591,1.591,0,0,1,1.163-1.608c28.325-5.005,37.133-23.58,38.822-27.911a6.087,6.087,0,0,0,.632-3.708A6.342,6.342,0,0,0,321.1,405.127ZM284.39,430.105a13.522,13.522,0,0,0-11.076,13.425v8.929A15.961,15.961,0,0,1,257.371,468.4H37.943A15.961,15.961,0,0,1,22,452.459V316.807a15.962,15.962,0,0,1,15.943-15.944H257.371a15.962,15.962,0,0,1,15.943,15.944v64.928c0,28.525,24.2,32.764,37.173,34.114C306.528,420.91,298.767,427.564,284.39,430.105Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.831,397H218.1a6,6,0,1,0,0,12h12.727a6,6,0,0,0,0-12Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.363,409H194.8a6,6,0,0,0,0-12H134.363a6,6,0,0,0,0,12Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.831,360.264H146.363a6,6,0,1,0,0,12h84.468a6,6,0,1,0,0-12Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.831,323.524H189.377a6,6,0,0,0,0,12h41.454a6,6,0,1,0,0-12Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.363,335.524H166a6,6,0,0,0,0-12H146.363a6,6,0,0,0,0,12Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.831,433.741H173.739a6,6,0,0,0,0,12h57.092a6,6,0,1,0,0-12Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.438,433.741H66.253a6,6,0,1,0,0,12h84.185a6,6,0,0,0,0-12Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.057,22.276H254.629A27.975,27.975,0,0,0,226.686,50.22v64.928c0,18.21-13.711,21-28.987,22.428a41.5,41.5,0,0,0-6.8.963,6.344,6.344,0,0,0-4.833,5.177,6.087,6.087,0,0,0,.632,3.708c1.689,4.331,10.5,22.906,38.823,27.911a1.592,1.592,0,0,1,1.162,1.608v8.929a27.974,27.974,0,0,0,27.943,27.943H474.057A27.974,27.974,0,0,0,502,185.872V50.22A27.975,27.975,0,0,0,474.057,22.276ZM490,185.872a15.961,15.961,0,0,1-15.943,15.943H254.629a15.961,15.961,0,0,1-15.943-15.943v-8.929a13.52,13.52,0,0,0-11.075-13.424c-14.355-2.538-22.122-9.192-26.088-14.258,12.975-1.351,37.163-5.6,37.163-34.113V50.22a15.962,15.962,0,0,1,15.943-15.944H474.057A15.962,15.962,0,0,1,490,50.22Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.747,93.677H361.011a6,6,0,0,0,0,12h84.736a6,6,0,0,0,0-12Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.86,142.416a6,6,0,0,0,0-12H361.011a6,6,0,0,0,0,12Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.747,130.416H431.6a6,6,0,0,0,0,12h14.146a6,6,0,0,0,0-12Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.859,167.154h-51.69a6,6,0,0,0,0,12h51.69a6,6,0,0,0,0-12Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.747,167.154H346.86a6,6,0,0,0,0,12h98.887a6,6,0,1,0,0-12Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.011,68.938h11.122a6,6,0,0,0,0-12H361.011a6,6,0,0,0,0,12Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.747,56.938H395.818a6,6,0,0,0,0,12h49.929a6,6,0,0,0,0-12Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.937,136.055v-52.5a6,6,0,0,0-1.758-4.243l-35-35a6,6,0,0,0-8.485,0l-35,35a6,6,0,0,0-1.757,4.243v52.5a6,6,0,0,0,6,6h70A6,6,0,0,0,344.937,136.055Zm-35.539-6h-10v-10.29h10Zm23.539,0H321.4v-16.29a6,6,0,0,0-6-6h-22a6,6,0,0,0-6,6v16.29H274.937V86.04l29-29,29,29Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.392,425.149a6,6,0,0,0,4.934-2.586l30.9-44.655a40.1,40.1,0,0,0-5.528-52.074c-16.71-15.915-43.894-15.913-60.6,0a40.1,40.1,0,0,0-5.528,52.075l30.894,44.654A6,6,0,0,0,85.392,425.149ZM63.368,334.523a32.291,32.291,0,0,1,44.048,0,28.154,28.154,0,0,1,3.936,36.558L85.392,408.6,59.433,371.082A28.154,28.154,0,0,1,63.368,334.523Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.945,354.979a24.554,24.554,0,1,0-24.553,24.553A24.58,24.58,0,0,0,109.945,354.979Zm-37.107,0a12.554,12.554,0,1,1,12.554,12.553A12.569,12.569,0,0,1,72.838,354.979Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.962,322.6a56.639,56.639,0,1,0,56.639-56.64A56.7,56.7,0,0,0,354.962,322.6Zm101.278,0a44.639,44.639,0,1,1-44.639-44.64A44.69,44.69,0,0,1,456.24,322.6Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.6,401a90.5,90.5,0,0,0-90.4,90.4,6,6,0,0,0,6,6H496a6,6,0,0,0,6-6A90.5,90.5,0,0,0,411.6,401ZM333.43,485.4a78.4,78.4,0,0,1,156.342,0Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.4,127.883A56.64,56.64,0,1,0,43.76,71.243,56.7,56.7,0,0,0,100.4,127.883Zm0-101.279A44.64,44.64,0,1,1,55.76,71.243,44.689,44.689,0,0,1,100.4,26.6Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.4,149.642a90.5,90.5,0,0,0-90.4,90.4,6,6,0,0,0,6,6H184.8a6,6,0,0,0,6-6A90.5,90.5,0,0,0,100.4,149.642Zm-78.171,84.4a78.4,78.4,0,0,1,156.342,0Z",
    style: {
      fill: "#2eca8b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.92c8d51d57dac5367bd643adb88e319a.svg";
export { ForwardRef as ReactComponent };